import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './proteccionDatos.module.scss'
const ProteccionDatos = () => {
  return (
    <div className={styles.proteccion_datos}>
      <span className={styles.title_proteccion}>
        <FormattedMessage id="funnel.informacion_proteccion_datos" />
      </span>
      <span className={styles.title_funnel}>
        <FormattedMessage id="funnel.finalidades" />:{' '}
      </span>
      <FormattedMessage id="funnel.finalidades_text" />
      <span className={styles.title_funnel}>
        <FormattedMessage id="funnel.legitimacion" />:{' '}
      </span>
      <FormattedMessage id="funnel.legitimacion_text" />
      <span className={styles.title_funnel}>
        <FormattedMessage id="funnel.destinatarios" />:{' '}
      </span>
      <FormattedMessage id="funnel.destinatarios_text" />
      <span className={styles.title_funnel}>
        <FormattedMessage id="funnel.derechos" />:{' '}
      </span>
      <FormattedMessage id="funnel.derechos_text" />
      <span className={styles.title_funnel}>
        <FormattedMessage id="funnel.informacion_adicional" />:{' '}
      </span>
      <FormattedMessage id="funnel.informacion_adicional_text" />
    </div>
  )
}

export default ProteccionDatos
